import axios from 'axios';
import { CUSTOMER_API_BASE_URL } from '../../../constants';
import { localStorageUtil } from '../../utils/localStorageUtil';

export const apiGqCustomerClient = axios.create({
    baseURL: CUSTOMER_API_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
    },
});

apiGqCustomerClient.defaults.trailingSlash = false;

apiGqCustomerClient.interceptors.request.use(
    config => {
        const accessToken = localStorageUtil.getItem('_gqcust_at');

        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }

        return config;
    },
    error => Promise.reject(error)
);

apiGqCustomerClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        const originalRequest = error.config;
        if (typeof error.response === 'undefined') {

            return Promise.reject(error);
        }

        if (
            [401, 403].includes(error.response.status) &&
            originalRequest.url === '/v0.1/authentication/platform/regenerate-token'
        ) {
            window.location.href = '/';
            return Promise.reject(error);
        }

        if ([401, 403].includes(error.response.status)) {
            const refreshToken = localStorageUtil.getItem('_gqcust_rt');

            if (refreshToken) {
                const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));
                const now = Math.ceil(Date.now() / 1000);

                if (tokenParts.exp > now) {
                    return apiGqCustomerClient
                        .post(`/v0.1/authentication/platform/regenerate-token`, { "refresh_token": refreshToken })
                        .then((response) => {
                            localStorageUtil.setItem('_gqcust_at', response.data.data.access_token);
                            localStorageUtil.setItem('_gqcust_rt', response.data.data.refresh_token);
                            apiGqCustomerClient.defaults.headers['Authorization'] =
                                'Bearer ' + response.data.data.access_token;
                            originalRequest.headers['Authorization'] =
                                'Bearer ' + response.data.data.access_token;
                            return apiGqCustomerClient(originalRequest);
                        })
                        .catch((err) => {
                            window.location.href = '/';
                            localStorageUtil.clear();
                        });
                } else {
                    window.location.href = '/';
                    localStorageUtil.clear();
                }
            } else {
                window.location.href = '/';
                localStorageUtil.clear();
            }
        }
        return Promise.reject(error);
    }
);
